module.exports = __webpack_public_path__ + "static/media/cross.856343c3.svg";